import { useSelector } from '~/_shared/utils/hooks/useSelector';
import type { AppState } from '~/store/app.store';

const locationFinderSelector = (state: AppState) => state.map.mapSettings.data.toolsState.locationFinder;
export const useLocationFinderSelector = () => useSelector(locationFinderSelector);

const isLocationFinderActiveSelector = (state: AppState) => locationFinderSelector(state).latLng !== null;
export const useIsLocationFinderSelectorActive = () => useSelector(isLocationFinderActiveSelector);
